import { render, staticRenderFns } from "./oldMetalInManage.vue?vue&type=template&id=1c1a6eaa&scoped=true&"
import script from "./oldMetalInManage.vue?vue&type=script&lang=js&"
export * from "./oldMetalInManage.vue?vue&type=script&lang=js&"
import style0 from "./oldMetalInManage.vue?vue&type=style&index=0&id=1c1a6eaa&scoped=true&lang=scss&"
import style1 from "./oldMetalInManage.vue?vue&type=style&index=1&lang=css&"
import style2 from "./oldMetalInManage.vue?vue&type=style&index=2&id=1c1a6eaa&scoped=true&lang=scss&"
import style3 from "./oldMetalInManage.vue?vue&type=style&index=3&id=1c1a6eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a6eaa",
  null
  
)

export default component.exports